export const suggestedProductListDispatcher = () => ({
  onSuggestedProductClick: () => undefined
});